import styled from 'styled-components/macro'
import { theme } from 'styled-tools'

const Count = styled.div`
  background-color: ${theme('quantityBox')};
  padding: 0.3rem 0.8rem;
  z-index: 20;
  border-radius: 15px;
  color: ${theme('quantityText')};
  margin-left: 7px;
  display: flex;
  align-items: center;
  justify-content: center;
  line-height: 1;
  text-align: center;
`

export { Count }
